// extracted by mini-css-extract-plugin
export var defaultWrapper = "_je-3";
export var downloadButton = "_je-4";
export var fileContainer = "_je-9 _je-7";
export var fileContainerBase = "_je-7";
export var fileContainerFixedHeight = "_je-8 _je-7";
export var fileInfo = "_je-5";
export var fileInfoWidthRestricted = "_je-6";
export var fileType = "_je-1";
export var fileTypeName = "_je-2";
export var image = "_je-0";
export var link = "_je-b";
export var overflowEllipsis = "_je-a";